import React, { useEffect } from 'react';
import '../../styles/tokens.css';
import '../../styles/components.css';
import '../../styles/modules/base.css';
import './components/Hero/hero.css';
import './components/Orders/orders.css';
import './components/Services/services.css';
import './components/Directions/directions.css';
import './components/WhyUs/why-us.css';
import './components/Reviews/reviews.css';
import './components/FAQ/faq.css';
import '../../styles/responsive-base.css';
import '../../styles/responsive-2k.css';
import '../../styles/responsive-1920.css';
import '../../styles/responsive-1050.css';
import '../../styles/responsive-820.css';
import '../../styles/responsive-480.css';
import './components/FAQ/how-responsive.css';

import { useAuth } from '../../state/auth';
import { Header, MobileDrawer } from '../../ui';
import { Footer } from './components/Footer/Footer';
import { LandingHero } from './components/Hero/LandingHero';
import { LandingOrders } from './components/Orders/LandingOrders';
import { LandingServices } from './components/Services/LandingServices';
import { LandingDirections } from './components/Directions/LandingDirections';
import { LandingWhyUs } from './components/WhyUs/LandingWhyUs';
import { LandingReviews } from './components/Reviews/LandingReviews';
import { LandingFAQ } from './components/FAQ/LandingFAQ';

function requestedSection() {
  const query = window.location.hash.split('?')[1] ?? '';
  const section = new URLSearchParams(query).get('section');
  return section === 'how' || section === 'reviews' || section === 'benefits' ? section : null;
}

function scrollToRequestedSection(behavior: ScrollBehavior) {
  const section = requestedSection();
  if (!section) return;
  window.requestAnimationFrame(() => {
    const target = document.getElementById(section);
    if (!target) return;
    if (behavior === 'auto') {
      window.scrollTo({
        behavior: 'instant' as ScrollBehavior,
        top: window.scrollY + target.getBoundingClientRect().top,
      });
      return;
    }
    target.scrollIntoView({ behavior, block: 'start' });
  });
}

function scheduleInitialSectionScroll() {
  return [0, 250, 1000, 2500].map((delay) => window.setTimeout(() => {
    scrollToRequestedSection('auto');
  }, delay));
}

export function LandingScreen() {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const { user, status } = useAuth();
  const isAuthenticated = status === 'authenticated' && Boolean(user);
  const isCarrier = user?.active_role === 'carrier';
  const cabinetUrl = isCarrier ? '/portal/#carrier-dashboard' : '/portal/#my-requests';
  const displayName = user?.display_name || user?.email || (isCarrier ? 'Кабинет перевозчика' : 'Личный кабинет');

  useEffect(() => {
    let initialTimers = scheduleInitialSectionScroll();
    const onLoad = () => {
      initialTimers.forEach(window.clearTimeout);
      initialTimers = scheduleInitialSectionScroll();
    };
    const onHashChange = () => scrollToRequestedSection('smooth');
    window.addEventListener('load', onLoad);
    window.addEventListener('hashchange', onHashChange);
    return () => {
      initialTimers.forEach(window.clearTimeout);
      window.removeEventListener('load', onLoad);
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  useEffect(() => {
    const s1 = document.createElement('script');
    s1.src = '/scripts/ui-kit.js';
    s1.type = 'module';
    document.body.appendChild(s1);

    const s2 = document.createElement('script');
    s2.src = '/scripts/landing.js?v=20260925-how-layout';
    s2.type = 'module';
    document.body.appendChild(s2);

    const s3 = document.createElement('script');
    s3.src = '/scripts/carousel-control.js';
    s3.type = 'module';
    document.body.appendChild(s3);


    return () => {
      s1.remove();
      s2.remove();
      s3.remove();
    };
  }, []);

  return (
    <div className="landing-page" data-figma-node="125:48190">
      <Header
        menuExpanded={menuOpen}
        externalDrawer
        onMenuToggle={() => setMenuOpen((open) => !open)}
      />

      {menuOpen ? (
        <MobileDrawer
          variant={isAuthenticated ? (isCarrier ? 'carrier' : 'owner') : 'no log in'}
          onClose={() => setMenuOpen(false)}
          onLogoClick={() => setMenuOpen(false)}
        />
      ) : null}

      <main id="top">
        <LandingHero />
        <LandingOrders />
        <LandingServices />
        <LandingDirections />

        <div className="brand-ribbons" data-figma-node="3108:48228" aria-hidden="true">
          <div className="brand-ribbon-wrap brand-ribbon-wrap--yellow">
            <div className="brand-ribbon brand-ribbon--yellow">
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-a.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-b.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-b.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-c.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-a.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-c.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-b.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-b.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-b.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-yellow-b.svg" alt="" /><img className="brand-ribbon__arrow" src="/assets/figma/ribbon-arrow-right.svg" alt="" /></span>
            </div>
          </div>
          <div className="brand-ribbon-wrap brand-ribbon-wrap--green">
            <div className="brand-ribbon brand-ribbon--green">
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
              <span className="brand-ribbon__item"><img className="brand-ribbon__arrow brand-ribbon__arrow--left" src="/assets/figma/ribbon-arrow-left.svg" alt="" /><img className="brand-ribbon__logo" src="/assets/figma/ribbon-logo-green.svg" alt="" /></span>
            </div>
          </div>
        </div>

        <LandingWhyUs />
        <LandingReviews />
        <LandingFAQ />
      </main>

      <Footer />
    </div>
  );
}
